import { ca } from '@cian/analytics';


export function trackSelectPeriodType(isOfferEditing, product, actionLabel, siteType) {
  ca('eventSite', {
    name: 'oldevent',
    category: isOfferEditing ? 'Edit_ad' : 'New_ad',
    action: 'Select',
    label: actionLabel,
    page: {
      pageType: 'AddForm',
      siteType,
    },
    products: isOfferEditing ? [product] : [],
  });
}
